import _objectWithoutPropertiesLoose from '../../../@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js';
import _extends from '../../../@babel/runtime/helpers/esm/extends.js';
import * as React from 'react';
import FocusLockUI from './Lock.js';
import FocusTrap from './Trap.js';

var FocusLockCombination = /*#__PURE__*/React.forwardRef(function FocusLockUICombination(props, ref) {
  return /*#__PURE__*/React.createElement(FocusLockUI, _extends({
    sideCar: FocusTrap,
    ref: ref
  }, props));
});
var _ref = FocusLockUI.propTypes || {};
  _ref.sideCar;
  var propTypes = _objectWithoutPropertiesLoose(_ref, ["sideCar"]);
FocusLockCombination.propTypes = process.env.NODE_ENV !== "production" ? propTypes : {};
var FocusLock = FocusLockCombination;

export { FocusLock as default };
//# sourceMappingURL=Combination.js.map
